import { Component, isDevMode, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { AuthService } from '@reusable/services/auth/auth.service';
import * as globals from '@reusable/services/globals';
import { SharedService } from '@reusable/services/shared.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']

})
export class HeaderComponent implements OnInit {
  showProfileBlock: boolean = false;
  isOpen: boolean = false;
  isAuthenticated;
  isScrolled = false;
  currPos: number = 0;
  startPos: number = 0;
  changePos: number = 20;
  isHome: boolean = true;
  listing: boolean = false;
  previousUrl: string;
  urlFlag: string;
  noHeaders: boolean;
  currentPageTitle: string;
  isDev = isDevMode();
  appURL: any;
  homeUrl: string;
  discoverUrl: string;

  constructor(
    private auth: AuthService,
    private toastr: ToastrService,
    // private notificationBarService: NotificationBarService,
    public router: Router,
    private title: Title,
    private data: SharedService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.appURL = globals.appURL;
    this.homeUrl = environment.homeUrl;
    this.discoverUrl = environment.discoverUrl;
    this.isAuthenticated = this.auth.isLoggedIn();
    if (this.router.url === '/') {
      this.isHome = false;
    }
    this.activatedRoute.queryParams.subscribe((qp: any) => {
      if (!qp.noHeaders) {
        return;
      }
      const { noHeaders } = qp;
      if (noHeaders === 'true') {
        this.noHeaders = true;
      }
    });
    this.data.currentUrlFlag.subscribe((urlFlag: any) => {
      this.urlFlag = urlFlag;
      this.currentPageTitle = '';

      switch (urlFlag) {
        case 'request':
          this.currentPageTitle = 'طلباتي';
          break;
        case 'order':
          this.currentPageTitle = 'مشترياتي';
          break;
        case 'profile':
          this.currentPageTitle = 'الملف الشخصى';
          break;
        case 'notifications':
          this.currentPageTitle = 'التنبيهات';
          break;
        case 'wallet':
          this.currentPageTitle = 'رصيد سبيرو';
          break;
        case 'purchases':
          this.currentPageTitle = 'سلة المشتريات';
          break;
      }
      this.title.setTitle(this.currentPageTitle);
    });
  }

  menuToggle() {
    this.isOpen = !this.isOpen;
  }

  showProfile() {
    this.showProfileBlock = true;
  }

  logOut() {
    this.auth.logout();
  }
}